import React, { useEffect, useState } from "react";
import "./Pagination.scss";
import {
  ArrowLeft,
  ArrowRight,
  DoubleArrowLeft,
  DoubleArrowRight,
} from "../icons"; // Custom icon components

// Pagination Component
const Pagination = ({
  targetId,            // ID of the container whose children are being paginated
  itemsPerPage = 5,    // Number of items to show per page
  size = "md",         // Size for styling purposes
}) => {

  /* === useState === */
  const [currentPage, setCurrentPage] = useState(1); // Tracks current page
  const [items, setItems] = useState([]);            // Stores child elements from the target container
  /* === End useState === */

  /* === useEffect to collect items === */
  useEffect(() => {
    const container = document.getElementById(targetId); // Get container by ID
    if (container) {
      const children = Array.from(container.children);   // Convert children to array
      setItems(children);                                // Store in state
    }
  }, [targetId]); // Runs when component mounts or targetId changes
  /* === End useEffect === */

  /* === useEffect to control visibility of items === */
  useEffect(() => {
    const container = document.getElementById(targetId);
    if (container && items.length > 0) {
      items.forEach((item, index) => {
        const start = (currentPage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        // Only display items in the current page's range
        item.style.display = index >= start && index < end ? "block" : "none";
      });
    }
  }, [items, currentPage, itemsPerPage, targetId]);
  /* === End useEffect === */

  // Total number of pages
  const totalPages = Math.ceil(items.length / itemsPerPage);

  // Go to a specific page
  const goToPage = (page) => setCurrentPage(page);

  // Hide pagination if only one page
  if (totalPages <= 1) return null;

  return (
    <div className={`pagination-wrapper ${size}`}>
      {/* First Page Button */}
      <button
        onClick={() => goToPage(1)}
        disabled={currentPage === 1}
        className="borderWrapperJustCorner"
      >
        <DoubleArrowLeft size={size} />
      </button>

      {/* Previous Page Button */}
      <button
        onClick={() => goToPage(currentPage - 1)}
        disabled={currentPage === 1}
        className="borderWrapperJustCorner"
      >
        <ArrowLeft size={size} />
      </button>

      {/* Page Number Buttons */}
      {[...Array(totalPages)].map((_, idx) => {
        const page = idx + 1;
        return (
          <button
            key={page}
            onClick={() => goToPage(page)}
            className={
              currentPage === page
                ? "borderWrapperJustCorner active"
                : "borderWrapperJustCorner"
            }
          >
            {page}
          </button>
        );
      })}

      {/* Next Page Button */}
      <button
        onClick={() => goToPage(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="borderWrapperJustCorner"
      >
        <ArrowRight size={size} />
      </button>

      {/* Last Page Button */}
      <button
        onClick={() => goToPage(totalPages)}
        disabled={currentPage === totalPages}
        className="borderWrapperJustCorner"
      >
        <DoubleArrowRight size={size} />
      </button>
    </div>
  );
};

export default Pagination;
